// Get All Disputes
export const GET_DISPUTES = "GET_DISPUTES"
export const GET_DISPUTES_SUCCESS = "GET_DISPUTES_SUCCESS"
export const GET_DISPUTES_FAIL = "GET_DISPUTES_FAIL"

// Get Dispute By ID
export const GET_DISPUTE = "GET_DISPUTE"
export const GET_DISPUTE_SUCCESS = "GET_DISPUTE_SUCCESS"
export const GET_DISPUTE_FAIL = "GET_DISPUTE_FAIL"

// Create Dispute
export const CREATE_DISPUTE = "CREATE_DISPUTE"
export const CREATE_DISPUTE_SUCCESS = "CREATE_DISPUTE_SUCCESS"
export const CREATE_DISPUTE_FAIL = "CREATE_DISPUTE_FAIL"

// Update Dispute
export const UPDATE_DISPUTE = "UPDATE_DISPUTE"
export const UPDATE_DISPUTE_SUCCESS = "UPDATE_DISPUTE_SUCCESS"
export const UPDATE_DISPUTE_FAIL = "UPDATE_DISPUTE_FAIL"

// Delete Dispute
export const DELETE_DISPUTE = "DELETE_DISPUTE"
export const DELETE_DISPUTE_SUCCESS = "DELETE_DISPUTE_SUCCESS"
export const DELETE_DISPUTE_FAIL = "DELETE_DISPUTE_FAIL"

// Change Dispute Status
export const CHANGE_DISPUTE_STATUS = "CHANGE_DISPUTE_STATUS"
export const CHANGE_DISPUTE_STATUS_SUCCESS = "CHANGE_DISPUTE_STATUS_SUCCESS"
export const CHANGE_DISPUTE_STATUS_FAIL = "CHANGE_DISPUTE_STATUS_FAIL"

// Add Dispute Log
export const ADD_DISPUTE_LOG = "ADD_DISPUTE_LOG"
export const ADD_DISPUTE_LOG_SUCCESS = "ADD_DISPUTE_LOG_SUCCESS"
export const ADD_DISPUTE_LOG_FAIL = "ADD_DISPUTE_LOG_FAIL"

// Respond to Dispute
export const RESPOND_TO_DISPUTE = "RESPOND_TO_DISPUTE"
export const RESPOND_TO_DISPUTE_SUCCESS = "RESPOND_TO_DISPUTE_SUCCESS"
export const RESPOND_TO_DISPUTE_FAIL = "RESPOND_TO_DISPUTE_FAIL"

// Reject Dispute
export const REJECT_DISPUTE = "REJECT_DISPUTE"
export const REJECT_DISPUTE_SUCCESS = "REJECT_DISPUTE_SUCCESS"
export const REJECT_DISPUTE_FAIL = "REJECT_DISPUTE_FAIL"

// Reset
export const RESET_DISPUTE = "RESET_DISPUTE"
